export default __webpack_public_path__ + "static/media/nfl_contest_bg.2e20062c.png";